export default "__VITE_ASSET__75244634__"